// Animation durations in milliseconds

export const durations = {
  micro: 150, // e.g. Hover effects for smaller components
  short: 300, // e.g. Hover effects for bigger components
  medium: 500, // e.g. Shorter transition
  long: 950, // e.g. Longer transition
  gradient: 400,
}
